import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import media from "../../utils/mediaQueries"
import { white, black, brandPrimary } from "../../utils/colors"

const { se, desktop } = media

const LearningCenterSection = ({ icon, title, description, startLink }) => (
  <Wrapper>
    <Container>
      <IconBg>
        <StyledImg src={icon} alt={title} />
      </IconBg>
      <TextContainer>
        <h4>{title}</h4>
        <p>{description}</p>
      <PostLink to={startLink} rel="read">
        Read →
      </PostLink>
      </TextContainer>
      {/* <StyledList>
        {pageLinks.map(({ linkTitle, linkUrl }) => (
          <ArticleLink to={linkUrl}>
            <li>
              <ArticleDot />
              {linkTitle}
            </li>
          </ArticleLink>
        ))}
      </StyledList> */}
    </Container>
  </Wrapper>
)

LearningCenterSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  pageLinks: PropTypes.array,
  startLink: PropTypes.array.isRequired,
}

LearningCenterSection.defaultProps = {
  title: "Section Title",
  description:
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore aut amet, ex qui sint corrupti inventore dolorem voluptate commodi saepe quos at ratione quasi nesciunt doloribus. Repudiandae sed rem ex!",
  pageLinks: [
    {
      linkTitle: "Article",
      linkUrl: "/",
    },
  ],
}

export default LearningCenterSection

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${se &&
    se`
  margin-bottom: 30px;
  `}

  ${desktop &&
    desktop`
    max-width: 650px;
    margin-bottom: 50px;
  `}
`

const Container = styled.div`
  display: flex;

  ${se &&
    se`
  flex-direction: column;
  `}

  ${desktop &&
    desktop`
    flex-direction: row;
  `}
`

const PostLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.text};
  display: flex;
 justify-content: space-between;
 width: 100%;
 font-size: 14px;
`


const TextContainer = styled.div`
  ${desktop &&
    desktop`
  max-width: 470px;
  margin-right: 20px;
`}
`

const StyledList = styled.ul`
  margin-left: 0;
`

const ArticleDot = styled.span`
  display: inline-block;
  margin-right: 10px;
  border-radius: 10px;
  width: 10px;
  height: 10px;
  background-color: ${props => props.theme.accent};
`

const ArticleLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  color: ${props => props.theme.text};
  list-style: none;
`
const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.accent};
  cursor: pointer;

  ${desktop &&
    desktop`
    padding-left: 52px;
  `}
`

const StyledImg = styled.img`
  height: 25px;
  width: 25px;
  margin: 0;
`

const IconBg = styled.div`
  width: 32px;
  height: 32px;
  background: ${props => props.theme.bg};
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${se &&
    se`
  margin-bottom: 20px;
`}

  ${desktop &&
    desktop`
margin-bottom: 0px;
`}
`
